var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5709 1.83992L8.20692 8.20388C7.81639 8.5944 7.18323 8.5944 6.7927 8.20388L0.42874 1.83992C0.0382156 1.4494 0.0382156 0.816232 0.42874 0.425706C0.819265 0.0351804 1.45243 0.0351805 1.84295 0.425706L6.49981 5.08256C7.5 6 7.5 6 8.49981 5.08256L13.1567 0.425707C13.5472 0.035181 14.1804 0.035181 14.5709 0.425707C14.9614 0.816233 14.9614 1.4494 14.5709 1.83992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaratarrow);
export default __webpack_public_path__ + "static/media/caratarrow.0e81f403c42cd461fa294cd3ac40e650.svg";
export { ForwardRef as ReactComponent };